import React from "react";
import "./skills.css";
import { skills } from "../../data";

const groups = [
  { title: "Languages", items: skills.programming_skills },
  { title: "Web & Frameworks", items: skills.web_skills },
  { title: "Cloud & DevOps", items: skills.cloud_skills },
  { title: "Databases", items: skills.backend_skills },
  { title: "AI / ML", items: skills.ml_skills },
];

export default function SkillsComponent() {
  return (
    <section className="section section--soft" id="skills">
      <div className="section-inner">
        <h2 className="section-title">Skills</h2>
        <span className="section-title-accent" />
        <p className="section-subtitle">
          The tools and technologies I use to design, build, and ship.
        </p>

        <div className="skills-grid">
          {groups.map((g) => (
            <div className="skill-group" key={g.title}>
              <h3 className="skill-group-title">{g.title}</h3>
              <div className="skill-chips">
                {g.items.map((s) => (
                  <span className="skill-chip" key={s.name}>
                    {s.name}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
